
angular.module('aprima-legacy-common').value('widgetViews', [
    {
        id: '259e6a7b-64a8-437c-82b7-000000000001',
        name: 'allergies',
        displayName: 'Allergies',
        userPlaceable : true,
        view: '/patients/views/dashboard-widgets/allergiesTile.html'
    },
    {
        id: '259e6a7b-64a8-437c-82b7-000000000002',
        name: 'appointments',
        displayName: 'Appointments',
        userPlaceable : true,
        view: '/patients/views/dashboard-widgets/appointmentsTile.html'
    },
    {
        id: '259e6a7b-64a8-437c-82b7-000000000003',
        name: 'demographics',
        displayName: 'Demographics',
        userPlaceable : true,
        view: '/patients/views/dashboard-widgets/demographicsTile.html'
    },
    {
        id: '259e6a7b-64a8-437c-82b7-000000000004',
        name: 'header',
        displayName: 'Patient Header',
        userPlaceable : false,
        view: '/patients/views/dashboard-widgets/patientHeaderTile.html'
    },
    {
        id: '259e6a7b-64a8-437c-82b7-000000000009',
        name: 'problems',
        displayName: 'Problem List',
        userPlaceable : true,
        view: '/patients/views/dashboard-widgets/problemListTile.html'
    },
    {
        id: '259e6a7b-64a8-437c-82b7-000000000006',
        name: 'medications',
        displayName: 'Active Medications',
        userPlaceable : true,
        view: '/patients/views/dashboard-widgets/medicationsTile.html'
    },
    {
        id: '259e6a7b-64a8-437c-82b7-000000000012',
        name: 'visits',
        displayName: 'Visits',
        userPlaceable : true,
        view: '/patients/views/dashboard-widgets/visitsTile.html'
    },
    {
        id: '259e6a7b-64a8-437c-82b7-000000000010',
        name: 'remarks',
        displayName: 'Remarks',
        userPlaceable : true,
        view: '/patients/views/dashboard-widgets/remarksTile.html'
    },
    {
        id: '259e6a7b-64a8-437c-82b7-000000000008',
        name: 'orders',
        displayName: 'Orders',
        userPlaceable : true,
        view: '/patients/views/dashboard-widgets/ordersTile.html'
    },
    {
        id: '259e6a7b-64a8-437c-82b7-000000000007',
        name: 'observationResults',
        displayName: 'Observation Results',
        userPlaceable : true,
        view: '/patients/views/dashboard-widgets/observationResultsTile.html'
    },
    {
        id: '259e6a7b-64a8-437c-82b7-000000000011',
        name: 'vitals',
        displayName: 'Vitals',
        userPlaceable : true,
        view: '/patients/views/dashboard-widgets/vitalsTile.html'
    },
    {
        id: '259e6a7b-64a8-437c-82b7-000000000005',
        name: 'healthMaintenanceReminders',
        displayName: 'Health Reminders',
        userPlaceable : true,
        view: '/patients/views/dashboard-widgets/healthMaintenanceRemindersTile.html'
    },
    {
        id: '259e6a7b-64a8-437c-82b7-000000000013',
        name: 'attachments',
        displayName: 'Attachments',
        userPlaceable : true,
        view: '/patients/views/dashboard-widgets/attachmentsTile.html'
    },
    {
        id: '259e6a7b-64a8-437c-82b7-000000000014',
        name: 'observationValues',
        displayName: 'Observation Values',
        userPlaceable : true,
        view: '/patients/views/dashboard-widgets/observationValuesTile.html'
    },
    {
        id: '259e6a7b-64a8-437c-82b7-000000000015',
        name: 'diagnosisSummaries',
        displayName: 'Diagnosis Summaries',
        userPlaceable : true,
        view: '/patients/views/dashboard-widgets/diagnosisSummariesTiles.html'
    },
    {
        id: '259e6a7b-64a8-437c-82b7-000000000016',
        name: 'recalls',
        displayName: 'Recalls',
        userPlaceable : true,
        view: '/patients/views/dashboard-widgets/recallsTile.html'
    }
]);